import React from "react";
import { ModalTemplate } from "../../templates/ModalTemplate";
import { Toast } from "../../atoms/Toast";
import { MemberForm, MemberFormData } from "../form/MemberForm";
import { useMemberEditing, useMemberPage, useMemberToast } from "../../pages/members/hook";

type Props = {
  isOpen: boolean;
  onClose: () => void;
  onSubmit?: (data: MemberFormData) => void;
  defaultValues: MemberFormData;
  memberId: string;
  refetchMembers?: () => void;
};

export const EditMemberModal: React.FC<Props> = ({
  isOpen,
  onClose,
  onSubmit,
  defaultValues,
  memberId,
  refetchMembers
}) => {
  const { toast, showToast, hideToast } = useMemberToast();
  const { handleEditMember } = useMemberEditing(showToast, refetchMembers, onClose);

  const handleFormSubmit = (data: MemberFormData, onError: (message: string) => void) => {
    if (!memberId) {
      onError('Member ID is missing.');
      return;
    }
    handleEditMember(
      {
        username: data.name,
        role: data.userRole as any, // Ensure type matches UserRole
      },
      memberId,
      onError,
      () => {
        onSubmit?.(data);
      }
    );
  };

  if (!isOpen) return null;

  return (
    <div>
      {toast.visible && (
        <Toast
          message={toast.message}
          type={toast.type}
          onClose={hideToast}
        />
      )}
      <ModalTemplate
        isOpen={isOpen}
        title="Update Member"
        onClose={onClose}
      >
        <MemberForm handleSubmit={handleFormSubmit} defaultValues={defaultValues} mode="edit" />
      </ModalTemplate>
    </div>
  );
};
